import React from 'react';
import { useDatasetContext } from '@vivli/features/datasets/infrastructure/context';
import { AmrDatasetAdminDetailsComponent } from './amr-dataset-admin-details.component';
import { DatasetAdminDetailsComponent } from './dataset-admin-details.component';
import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export const DatasetAdminDetailsContainerComponent = () => {
    const { study } = useDatasetContext();
    const { isAmr } = useAssignedAppTypeContext();

    if (isAmr) {
        return <AmrDatasetAdminDetailsComponent study={study} />;
    }

    return <DatasetAdminDetailsComponent study={study} />;
};
